export const selectIsLoading = state => state.getIn(['newPerson', 'scheduleTour', 'isLoading']);
export const selectSaveTourActionResult = state =>
  state.getIn(['newPerson', 'scheduleTour', 'saveTourActionResult']);
